import React, { useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import FAQAccordion from './Accordion';

function ControlledTabs() {
    const [key, setKey] = useState("Travel");
    return (
        <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="tab-container"
        >
            <Tab eventKey="Travel" title="Travel" >
                <FAQAccordion activeKey={0} />
            </Tab>
            <Tab eventKey="Hotel/Accommodation" title="Hotel/Accommodation">
                <FAQAccordion activeKey={1} />
            </Tab>
            <Tab eventKey="Expense management" title="Expense management" >
                <FAQAccordion activeKey={2} />
            </Tab>
            <Tab eventKey="Kcare" title="Kcare" >
                <FAQAccordion activeKey={3} />
            </Tab>
        </Tabs>
    );
}

export default ControlledTabs;